/*
 * Objeto de estadpo Vuex.
 */
import Vue from "vue";
import Vuex from "vuex";

/* Inicializacion de Vuex */
Vue.use(Vuex);

/* Elementos principales */
import * as actions from "@/store/Main/actions";
import * as mutations from "@/store/Main/mutations";
import * as getters from "@/store/Main/getters";

/* Modules for extra functionality */
import LazLocalStorage from "@/shared/utils/LazLocalStorage.js";
import RolesModule from "@/admin/store/RolesModule";
import ProfilesModule from "@/admin/store/ProfilesModule";
import UsersModule from "@/admin/store/UsersModule";
import LegalModule from "@/legal/store/LegalModule";
import ESignModule from "@/esign/store/ESignModule";
import ESignTetrisModule from "@/esign/store/ESignTetrisModule";
import ESignJLLTModule from "@/esign/store/ESignJLLTModule";
import ESignConfigModule from "@/esign/store/ESignConfigModule";
import ESignTetrisConfigModule from "@/esign/store/ESignTetrisConfigModule";
import ESignJLLTConfigModule from "@/esign/store/ESignJLLTConfigModule";
import LegalConfigModule from "@/legal/store/LegalConfigModule";
import ChartsModule from "@/store/modules/ChartsModule";
import ESignHRConfigModule from "@/esign/store/ESignHRConfigModule";
import ESignHRModule from "@/esign/store/ESignHRModule";


/* Vuex main store creation */
const store = new Vuex.Store({
    modules: {
        RolesModule,
        ProfilesModule,
        UsersModule,
        LegalModule,
        ESignConfigModule,
        ESignTetrisConfigModule,
        ESignModule,
        ESignTetrisModule,
        ESignJLLTModule,
        ESignJLLTConfigModule,
        ESignHRConfigModule,
        ESignHRModule,
        LegalConfigModule,
        ChartsModule,
        ESignHRConfigModule
    },
    actions,
    mutations,
    getters,
    state: {
        langCode: LazLocalStorage.getWithExpiry("LazLangCode"),
        paramListItems: [
            {
                codParam: "*",
                langCode: "*",
                dictPairs: [{ name: "*", value: "..." }],
            },
        ],
        paramListCombos: [{ paramId: -1, langCode: "*", values: [] }],
        auth: {
            isBackLogin: false, // Flag para indicar si se está haciendo el login en api.
            isLoginError: false, // Flag Para indicar error en el login.
            isAuthReady: false, // Flag que marca si el flujo de autenticación ha terminado.
            jwtToken: null, // Authorization jwt token.
        },
        comboDefaultIItem: {
            value: null,
            name: "All",
        },
        widgetCardsBuffer: {
            isCollapsed: true,
            data: []
        },
        apiUrl: GlobalIrisInitProps.apiURL,
        appBaseUrl: GlobalIrisInitProps.appBaseUrl,
        isAuthenticating: false
    },
});
export default store;
